/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import UserIcon from "assets/images/bg-profile.jpeg";

import { useEffect, useState } from "react";
import { withAuthContext } from "context/Auth";
import axios from "axios";
import { Card } from "@mui/material";
import MDInput from "components/MDInput";
import swal from "sweetalert";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useCappedRetry } from "utils/retry";

function Details({ Token, id, CheckToken, currAdmin }) {
	const navigate = useNavigate();
	const [error, setError] = useState("");
	const [Loading, setLoading] = useState(false);
	const retrySubmit = useCappedRetry();

	const [state, setState] = useState({
		Name: "",
		TowerNo: currAdmin?.TowerNo,
		AppratmentNo: "",
		VehicleNumber: "",
		VisitPurpose: "",
		EntryTime: new Date(),
		// ExitTime: new Date(),
		Visiting: "",
		ContactNumber: "",
		Notes: "",
	});

	const handleChange = (name, value) => {
		setState({ ...state, [name]: value });
	};

	useEffect(() => {
		if (currAdmin?.TowerNo && !state.TowerNo) {
			handleChange("TowerNo", currAdmin.TowerNo);
		}
	}, [currAdmin]);

	const handleSubmit = () => {
		if (Token) {
			setLoading(true);

			axios
				.post(`${process.env.REACT_APP_PUBLIC_PATH}/Create-visitor`, state, {
					headers: {
						Authorization: `Bearer ${Token || localStorage.getItem("accessToken") || localStorage.getItem("token")}`
					}
				})
				.then((res) => {
					setLoading(false);
					navigate("/visitor");
					swal({
						text: res?.data?.message,
						button: {
							text: "Ok",
							closeModal: true
						},
						icon: res?.data?.status == 200 ? "success" : "error",
						time: 3000
					});
				})
				.catch((err) => {
					setLoading(false);
					swal({
						text: err?.response?.data?.message
							? err?.response?.data?.message
							: "There was some Error",
						button: {
							text: "Ok",
							closeModal: true
						},
						icon: "error",
						time: 3000
					});
				});
		} else {
			setLoading(false);
			retrySubmit(() => {
				CheckToken();
				handleSubmit();
			});
		}
	};

	return (
		<Card id="delete-account">
			<MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
				<MDTypography variant="h6" fontWeight="medium">
					Basic Details
				</MDTypography>
				<MDButton
					variant="gradient"
					color="dark"
					onClick={() => {
						if (!Loading) {
							handleSubmit();
						} else {
							swal({
								text: "Please Let This Task Complete First",
								button: {
									text: "Ok",
									closeModal: true
								},
								icon: "warning",
								time: 3000
							});
						}
					}}
				>
					add
				</MDButton>
			</MDBox>
			<MDBox pt={4} pb={3} px={3}>
				<MDBox component="form" role="form">
					<MDBox
						mb={2}
						pt={2}
						display="flex"
						justifyContent="center"
						alignItems="center"
						width="100%"
					>
						<MDBox pl={2} width="100%">
							<MDInput
								value={state?.Name}
								label="Name"
								variant="standard"
								fullWidth
								disabled={id !== "New"}
								onChange={(e) => handleChange("Name", e.target.value)}
							/>
						</MDBox>
						<MDBox pl={2} width="100%">
							<MDInput
								value={state?.TowerNo}
								label="TowerNo"
								variant="standard"
								fullWidth
								disabled={id !== "New"}
								onChange={(e) => handleChange("TowerNo", e.target.value)}
							/>
						</MDBox>{" "}
					</MDBox>
					<MDBox
						mb={2}
						pt={2}
						display="flex"
						justifyContent="center"
						alignItems="center"
						width="100%"
					>
						<MDBox pl={2} width="100%">
							<MDInput
								value={state?.AppratmentNo}
								label="AppratmentNo"
								variant="standard"
								fullWidth
								disabled={id !== "New"}
								onChange={(e) => handleChange("AppratmentNo", e.target.value)}
							/>
						</MDBox>
						<MDBox pl={2} width="100%">
							<MDInput
								value={state?.VehicleNumber}
								label="VehicleNumber"
								variant="standard"
								fullWidth
								disabled={id !== "New"}
								onChange={(e) => handleChange("VehicleNumber", e.target.value)}
							/>
						</MDBox>{" "}
					</MDBox>
					<MDBox
						mb={2}
						pt={2}
						display="flex"
						justifyContent="center"
						alignItems="center"
						width="100%"
					>
						<MDBox pl={2} width="100%">
							<MDInput
								value={state?.VisitPurpose}
								label="VisitPurpose"
								variant="standard"
								fullWidth
								disabled={id !== "New"}
								onChange={(e) => handleChange("VisitPurpose", e.target.value)}
							/>
						</MDBox>
						<MDBox pl={2} width="100%">
							<MDInput
								label="Entry Time"
								type="datetime-local"   // ⏰ always 24h
								value={moment(state?.EntryTime).format("YYYY-MM-DDTHH:mm")}
								onChange={(e) => handleChange("EntryTime", new Date(e.target.value))}
								InputLabelProps={{ shrink: true }}
								variant="standard"
								fullWidth
								disabled={id !== "New"}
							/>
						</MDBox>{" "}
					</MDBox>
					<MDBox
						mb={2}
						pt={2}
						display="flex"
						justifyContent="center"
						alignItems="center"
						width="100%"
					>
						{/* <MDBox pl={2} width="100%">
							<MDInput
								value={state?.ExitTime}
								label="ExitTime"
								variant="standard"
								fullWidth
								type="datetime-local"
								disabled={id !== "New"}
								onChange={(e) => handleChange("ExitTime", e.target.value)}
							/>
						</MDBox> */}
						<MDBox pl={2} width="100%">
							<MDInput
								value={state?.Visiting}
								label="Visiting"
								variant="standard"
								fullWidth
								disabled={id !== "New"}
								onChange={(e) => handleChange("Visiting", e.target.value)}
							/>
						</MDBox>{" "}
					</MDBox>
					<MDBox
						mb={2}
						pt={2}
						display="flex"
						justifyContent="center"
						alignItems="center"
						width="100%"
					>
						<MDBox pl={2} width="100%">
							<MDInput
								value={state?.ContactNumber}
								label="ContactNumber"
								variant="standard"
								fullWidth
								disabled={id !== "New"}
								onChange={(e) => handleChange("ContactNumber", e.target.value)}
							/>
						</MDBox>
						<MDBox pl={2} width="100%">
							<MDInput
								value={state?.Notes}
								label="Notes"
								variant="standard"
								fullWidth
								disabled={id !== "New"}
								onChange={(e) => handleChange("Notes", e.target.value)}
							/>
						</MDBox>{" "}
					</MDBox>
				</MDBox>
			</MDBox>
		</Card>
	);
}

export default withAuthContext(Details);
